import type {
  LoaderAssetsPayload,
} from "@bestowinc/tinkertoy-core";

import type { ModuleLoader } from "../module-loader";
import {
  getLoadingModuleLoadPromise,
  getModuleLoadPromise,
} from "../module-renderer/module-read-resource";
import type { ViewLoader } from "../view-loader";
import { getViewLoadPromise } from "../view-loader/view-read-resource";

/**
 * Starts CDN view and module imports as soon as the streaming assets phase
 * arrives. Uses the same dedupe maps as {@link TinkertoyShell} and
 * {@link ViewRenderer} so primed loads collapse onto in-flight promises.
 */
export function primeLoaderAssets(
  payload: LoaderAssetsPayload,
  loaders: {
    viewLoader: ViewLoader;
    moduleLoader: ModuleLoader;
  },
): void {
  const { loadedView, resolvedModuleVersions, loadingModule } = payload;

  // First: the loading module renders while everything else loads.
  if (loadingModule) {
    void getLoadingModuleLoadPromise(
      loaders.moduleLoader,
      loadingModule.moduleId,
      loadingModule.version,
    );
  }

  void getViewLoadPromise(
    loaders.viewLoader,
    loadedView.viewId,
    loadedView.viewVersion,
  );

  for (const moduleId of Object.keys(resolvedModuleVersions)) {
    const version = resolvedModuleVersions[moduleId];
    if (version === undefined) {
      continue;
    }
    void getModuleLoadPromise(loaders.moduleLoader, moduleId, version);
  }
}
